import type { $ZodConfig } from "zod/v4/core";

declare global {
  var __zod_globalConfig: $ZodConfig | undefined;
}

if (typeof window !== "undefined") {
  globalThis.__zod_globalConfig = Object.assign(globalThis.__zod_globalConfig ?? {}, { jitless: true });
}
